/* ============================================================================
   Who may open which page — the one table the sidebar, the command palette
   and the shell's route guard all read, so a page cannot be hidden in one and
   reachable from another.

   Keyed by the FIRST path segment, so a detail route (`edit-user/42`,
   `view-payslip/7`) inherits its listing's rule. A segment that is not listed
   here is open to every signed-in user.

   Roles arrive as both number and string, hence Number(). CLIENT-SIDE ONLY:
   the API behind these pages does not check role, so this hides screens, it
   does not secure data.
   ========================================================================== */

export const HR_CLOCK_IN_EMAIL = "ritika@rapidsofts.com";

export const isAdmin = (user) => Number(user?.role) === 1;
export const isAdminOrLead = (user) => isAdmin(user) || Number(user?.role) === 7;
const isHr = (user) => user?.email === HR_CLOCK_IN_EMAIL;
// an admin's own leave is not tracked through the portal
const isNotAdmin = (user) => !isAdmin(user);

const ADMIN = [
  "manage-leave",
  "leave-balance",
  "add-payslip",
  "manage-payslip",
  "view-payslip",
  "edit-payslip",
  "add-project",
  "manage-project",
  "update-project",
  "view-project",
  "add-todo",
  "manage-todo",
  "edit-todo",
  "birthday-wishes",
];

const ADMIN_OR_LEAD = [
  "saturday-working",
  "add-user",
  "manage-user",
  "edit-user",
  "manage-task",
  "add-tracker",
  "manage-tracker",
  "add-clickup",
  "manage-clickup",
  "add-anouncements",
  "annoucement-listing",
  "createFolder",
  "gallery",
  "add-inventory",
  "inventory-listing",
  "edit-inventory",
  // a lead's dashboard (views/dashbaord/Admin.js) opens leaves here
  "edit-leave",
];

const RULES = {
  ...Object.fromEntries(ADMIN.map((seg) => [seg, isAdmin])),
  ...Object.fromEntries(ADMIN_OR_LEAD.map((seg) => [seg, isAdminOrLead])),
  "clock-in": isHr,
  "my-leave": isNotAdmin,
  // admins see every project under manage-project
  "my-projects": isNotAdmin,
};

/** `to` is a route ("manage-user"), a pathname ("/edit-user/42") or a URL path with a query. */
export const canAccess = (to, user) => {
  const segment = (to ?? "").replace(/^\/+/, "").split(/[/?#]/)[0];
  const rule = RULES[segment];
  return rule ? Boolean(rule(user)) : true;
};
